import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CellularDeviceBlockData from 'app/Models/Content/CellularDeviceBlockData';
import React, {useState, useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import classNames from 'classnames';
import {getImageProps} from 'app/utilities/ImageProps';

const CellularDeviceBlock = ({data, context}: ComponentProps<CellularDeviceBlockData>) => {
  const [isIn, setIsIn] = useState(false);

  const {ref, inView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) setIsIn(true);
  }, [inView]);

  return (
    <a href={data.buttonLink.value} ref={ref} className={classNames('CellularDeviceBlock', {'slide-in': isIn})}>
      <div className='CellularDeviceBlock__wrap'>
        <Image {...getImageProps(data.image, context)} src={context.getEpiserverUrl(data.image.expandedValue.url)} alt='' />

        <div className='CellularDeviceBlock__phone-and-button'>
          <div className='CellularDeviceBlock__phone-and-button__content'>
            <span className='CellularDeviceBlock__phone-and-button__content__phone-name'>{data.name?.value}</span>

            {data.price?.value > 0 && (
              <span className='CellularDeviceBlock__phone-and-button__content__single-payment'>
                <span className='CellularDeviceBlock__phone-and-button__content__single-payment__symbol'>₪</span>

                {data.price.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </span>
            )}

            {data.singlePayment?.value > 0 ? (
              <div className='CellularDeviceBlock__phone-and-button__content__monthly-payment'>
                <span className='CellularDeviceBlock__phone-and-button__content__monthly-payment__monthly-value'>
                  תשלום חודשי ב-{data.monthlyPayments.value} תשלומים
                </span>

                <span className='CellularDeviceBlock__phone-and-button__content__monthly-payment__phone-value'>
                  <span className='CellularDeviceBlock__phone-and-button__content__monthly-payment__phone-value__symbol'>₪</span>
                  {data.singlePayment.value}
                </span>
              </div>
            ) : (
              data.fullPrice?.value > 0 && (
                <span className='CellularDeviceBlock__phone-and-button__content__full-price'>
                  ₪{data.fullPrice.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </span>
              )
            )}
          </div>

          <div className='CellularDeviceBlock__phone-and-button__all-items-link'>&#187;</div>
        </div>
      </div>
    </a>
  );
};

export default CellularDeviceBlock;
